import React from "react";
import "./ProjectsComponentStyles.css";
import { Button, Grid } from "@mui/material";
import { motion } from "framer-motion";
import "./ProjectsComponentStyles.css";

function ProjectsComponent() {
  return (
    <div className="projectsComponent">
      <h1 className="sectionHeaders" style={{ color: "#8B0000" }}>
        Projects
      </h1>
      <Grid
        container
        sx={{
          paddingX: "10%",
        }}
        display="flex"
        alignItems="center"
        jusifyContent="space-evenly"
        flexDirection={{
          xs: "column",
          sm: "column",
          md: "row",
          lg: "row",
        }}
      >
        <Grid
          item
          xs={6}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <svg
            width="360"
            height="551"
            viewBox="0 0 360 551"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Frame 29">
              <g id="iPhone 11 Pro Max" filter="url(#filter0_d_124_555)">
                <rect
                  x="59"
                  y="32"
                  width="242.609"
                  height="485.945"
                  rx="27.5479"
                  fill="#110F0F"
                  shape-rendering="crispEdges"
                />
                <g id="Device">
                  <path
                    id="Vector"
                    d="M61.2055 482.575C61.2337 487.719 62.3289 492.809 64.4975 497.479C66.8248 502.491 70.3311 506.924 74.6655 510.349C78.9194 513.71 83.9505 516.065 89.2538 517.182C92.081 517.778 94.9302 517.945 97.8082 517.945C100.925 517.945 104.041 517.945 107.158 517.945C112.713 517.945 118.268 517.945 123.823 517.945C131.078 517.945 138.333 517.945 145.587 517.945C153.842 517.945 162.097 517.945 170.352 517.945C178.918 517.945 187.485 517.945 196.052 517.945C204.191 517.945 212.331 517.945 220.47 517.945C227.43 517.945 234.391 517.945 241.352 517.945C246.495 517.945 251.64 517.945 256.784 517.945C259.352 517.945 261.921 517.945 264.489 517.945C268.142 517.945 271.754 517.48 275.255 516.414C280.477 514.825 285.313 512.015 289.275 508.256C293.254 504.481 296.328 499.79 298.199 494.632C299.61 490.742 300.309 486.631 300.317 482.497C300.319 481.547 300.317 480.598 300.317 479.648C300.317 477.419 300.317 475.189 300.317 472.959C300.317 469.556 300.317 466.153 300.317 462.75C300.317 458.296 300.317 453.842 300.317 449.388C300.317 444.034 300.317 438.679 300.317 433.325C300.317 427.13 300.317 420.933 300.317 414.738C300.317 407.846 300.317 400.954 300.317 394.062C300.317 386.593 300.317 379.123 300.317 371.654C300.317 363.769 300.317 355.885 300.317 348.001C300.317 339.733 300.317 331.465 300.317 323.197C300.317 314.706 300.317 306.215 300.317 297.725C300.317 289.153 300.317 280.581 300.317 272.009C300.317 263.451 300.317 254.893 300.317 246.334C300.317 237.884 300.317 229.434 300.317 220.984C300.317 212.784 300.317 204.584 300.317 196.384C300.317 188.594 300.317 180.804 300.317 173.014C300.317 165.667 300.317 158.319 300.317 150.972C300.317 144.23 300.317 137.487 300.317 130.745C300.317 124.725 300.317 118.706 300.317 112.686C300.317 107.535 300.317 102.383 300.317 97.2304C300.317 93.0073 300.317 88.7842 300.317 84.5604C300.317 81.415 300.317 78.2696 300.317 75.1242C300.317 73.1785 300.317 71.2335 300.317 69.2878C300.317 68.472 300.325 67.6554 300.313 66.8396C300.235 61.6843 299.019 56.5614 296.768 51.9227C294.342 46.9226 290.731 42.5189 286.3 39.166C282.038 35.9415 277.056 33.7043 271.815 32.669C269.068 32.1263 266.305 32 263.517 32C260.294 32 257.071 32 253.847 32C248.213 32 242.579 32 236.945 32C229.66 32 222.375 32 215.091 32C206.79 32 198.489 32 190.189 32C181.625 32 173.062 32 164.499 32C156.39 32 148.281 32 140.173 32C133.27 32 126.366 32 119.464 32C114.405 32 109.346 32 104.287 32C101.832 32 99.3759 32 96.9203 32C93.1029 32 89.3201 32.5356 85.6825 33.7135C80.504 35.3903 75.7445 38.2669 71.8488 42.0707C67.8988 45.9282 64.8797 50.7187 63.099 55.946C61.8332 59.6617 61.2118 63.558 61.2048 67.4811C61.2027 68.4776 61.2048 69.4734 61.2048 70.4699C61.2048 72.7508 61.2048 75.0317 61.2048 77.3126C61.2048 80.758 61.2048 84.204 61.2048 87.6494C61.2048 92.1413 61.2048 96.6326 61.2048 101.125C61.2048 106.512 61.2048 111.9 61.2048 117.287C61.2048 123.512 61.2048 129.736 61.2048 135.961C61.2048 142.877 61.2048 149.794 61.2048 156.71C61.2048 164.178 61.2048 171.646 61.2048 179.114C61.2048 187.034 61.2048 194.955 61.2048 202.876C61.2048 211.154 61.2048 219.433 61.2048 227.712C61.2048 236.208 61.2048 244.705 61.2048 253.202C61.2048 261.752 61.2048 270.302 61.2048 278.852C61.2048 287.431 61.2048 296.01 61.2048 304.589C61.2048 313.032 61.2048 321.474 61.2048 329.918C61.2048 338.106 61.2048 346.294 61.2048 354.482C61.2048 362.256 61.2048 370.029 61.2048 377.803C61.2048 385.129 61.2048 392.456 61.2048 399.782C61.2048 406.499 61.2048 413.216 61.2048 419.933C61.2048 425.907 61.2048 431.881 61.2048 437.856C61.2048 442.989 61.2048 448.121 61.2048 453.255C61.2048 457.439 61.2048 461.623 61.2048 465.808C61.2048 468.909 61.2048 472.011 61.2048 475.113C61.2048 477.007 61.2048 478.901 61.2048 480.794C61.2055 481.388 61.2055 481.981 61.2055 482.575Z"
                    stroke="black"
                    stroke-width="1.65287"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <g id="Top">
                  <g id="POLYLINE 590">
                    <path
                      id="Vector_2"
                      d="M206.657 51.2823C206.656 49.6694 205.616 48.1922 204.097 47.6479C202.579 47.1044 200.836 47.5863 199.813 48.8325C198.789 50.0787 198.656 51.8823 199.484 53.2649C200.313 54.6482 201.965 55.3817 203.547 55.0685C205.123 54.756 206.368 53.4556 206.612 51.8676C206.641 51.674 206.657 51.4781 206.657 51.2823Z"
                      stroke="#FFFEFE"
                      stroke-width="1.65287"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <g id="POLYLINE 589">
                    <path
                      id="Vector_3"
                      d="M191.901 51.2677C191.901 50.0417 191.161 48.9378 190.128 48.6244C189.713 48.4982 189.275 48.5332 188.849 48.5332C187.71 48.5332 186.572 48.5332 185.433 48.5332C182.018 48.5332 178.603 48.5332 175.188 48.5332C173.408 48.5332 171.395 48.5333 169.756 48.5479C167.387 48.8385 166.855 52.6671 169.043 53.7709C169.436 53.9688 169.837 54.0005 170.258 54.0021C171.18 54.0062 172.103 54.0021 173.025 54.0021C176.381 54.0021 179.737 54.0021 183.093 54.0021C185.225 54.0021 187.37 54.0835 189.501 54.0021C190.522 53.9631 191.436 53.2841 191.773 52.1485C191.859 51.8652 191.901 51.5664 191.901 51.2677Z"
                      fill="white"
                      stroke="black"
                      stroke-width="1.65287"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
                <g id="Screen">
                  <path
                    id="Vector_4"
                    d="M123.48 45.2354C117.317 45.2354 111.154 45.2354 104.991 45.2354C102.251 45.2354 99.5106 45.234 96.7705 45.2354C94.8651 45.2361 92.9803 45.4249 91.1286 45.8829C86.7063 46.9762 82.6739 49.4631 79.7121 52.9158C76.7502 56.3693 74.9113 60.728 74.513 65.2558C74.4127 66.3914 74.4275 67.5278 74.4275 68.6662C74.4275 70.4148 74.4275 72.1626 74.4275 73.9112C74.4275 76.8172 74.4275 79.724 74.4275 82.63C74.4275 86.5963 74.4275 90.5627 74.4275 94.5283C74.4275 99.4358 74.4275 104.344 74.4275 109.251C74.4275 114.973 74.4275 120.693 74.4275 126.414C74.4275 132.85 74.4275 139.286 74.4275 145.722C74.4275 152.782 74.4275 159.843 74.4275 166.903C74.4275 174.46 74.4275 182.016 74.4275 189.572C74.4275 197.491 74.4275 205.409 74.4275 213.327C74.4275 221.517 74.4275 229.707 74.4275 237.897C74.4275 246.295 74.4275 254.693 74.4275 263.091C74.4275 271.492 74.4275 279.894 74.4275 288.295C74.4275 296.635 74.4275 304.976 74.4275 313.316C74.4275 321.485 74.4275 329.654 74.4275 337.823C74.4275 345.753 74.4275 353.682 74.4275 361.612C74.4275 369.104 74.4275 376.595 74.4275 384.086C74.4275 391.073 74.4275 398.061 74.4275 405.049C74.4275 411.421 74.4275 417.794 74.4275 424.166C74.4275 429.843 74.4275 435.519 74.4275 441.196C74.4275 446.002 74.4275 450.809 74.4275 455.615C74.4275 459.474 74.4275 463.333 74.4275 467.192C74.4275 469.999 74.4275 472.807 74.4275 475.614C74.4275 477.247 74.4275 478.878 74.4275 480.51C74.4275 481.991 74.4515 483.461 74.6733 484.932C75.3477 489.404 77.4268 493.618 80.568 496.879C83.7233 500.154 87.8885 502.403 92.3652 503.24C94.5085 503.641 96.6511 503.619 98.8171 503.619C102.354 503.619 105.89 503.619 109.427 503.619C115.183 503.619 120.94 503.619 126.697 503.619C134.023 503.619 141.349 503.619 148.675 503.619C156.879 503.619 165.084 503.619 173.288 503.619C181.669 503.619 190.051 503.619 198.432 503.619C206.34 503.619 214.249 503.619 222.157 503.619C228.952 503.619 235.748 503.619 242.544 503.619C247.476 503.619 252.409 503.619 257.341 503.619C259.78 503.619 262.218 503.619 264.656 503.619C268.005 503.619 271.28 502.996 274.33 501.59C278.48 499.678 281.972 496.464 284.229 492.5C286.118 489.183 287.082 485.419 287.095 481.61C287.098 480.729 287.095 479.848 287.095 478.966C287.095 476.851 287.095 474.734 287.095 472.619C287.095 469.358 287.095 466.096 287.095 462.835C287.095 458.577 287.095 454.318 287.095 450.059C287.095 444.898 287.095 439.738 287.095 434.577C287.095 428.607 287.095 422.637 287.095 416.667C287.095 410.013 287.095 403.358 287.095 396.704C287.095 389.497 287.095 382.291 287.095 375.085C287.095 367.42 287.095 359.754 287.095 352.09C287.095 344.053 287.095 336.017 287.095 327.98C287.095 319.705 287.095 311.43 287.095 303.155C287.095 294.777 287.095 286.398 287.095 278.02C287.095 269.626 287.095 261.231 287.095 252.837C287.095 244.491 287.095 236.146 287.095 227.8C287.095 219.708 287.095 211.615 287.095 203.523C287.095 195.747 287.095 187.971 287.095 180.196C287.095 172.847 287.095 165.499 287.095 158.15C287.095 151.304 287.095 144.457 287.095 137.611C287.095 131.454 287.095 125.296 287.095 119.138C287.095 113.741 287.095 108.343 287.095 102.946C287.095 98.4185 287.095 93.8914 287.095 89.3643C287.095 85.8017 287.095 82.239 287.095 78.6764C287.095 76.229 287.095 73.7816 287.095 71.3342C287.095 70.09 287.095 68.8459 287.095 67.601C287.095 64.9676 286.722 62.3744 285.841 59.884C284.32 55.5831 281.446 51.8112 277.7 49.1975C274.009 46.6233 269.584 45.2545 265.086 45.2347C258.881 45.208 252.675 45.2347 246.469 45.2347C243.751 45.2347 241.033 45.2319 238.315 45.2347C237.291 45.2361 236.329 45.4461 235.668 46.2922C234.589 47.673 234.719 49.7787 234.338 51.4019C233.819 53.6119 232.95 55.8036 231.45 57.5409C228.967 60.4159 225.306 60.6497 221.695 60.6497C215.105 60.6497 208.516 60.6497 201.927 60.6497C195.239 60.6497 188.551 60.6497 181.863 60.6497C178.468 60.6497 175.072 60.6497 171.676 60.6497C163.705 60.6497 155.733 60.6497 147.761 60.6497C145.059 60.6497 142.358 60.6497 139.656 60.6497C138.16 60.6497 136.837 61.014 135.368 60.6759C130.863 59.6381 128.294 55.9121 127.238 51.6252C126.654 49.2461 126.91 45.2312 123.48 45.2354Z"
                    fill="#FFFDFD"
                    stroke="black"
                    stroke-width="1.65287"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
              <motion.g id="finished" initial={{ opacity: 0 }}>
                <g id="Rectangle 14" filter="url(#filter1_f_124_555)">
                  <rect
                    x="104"
                    y="188"
                    width="154.119"
                    height="172"
                    rx="13.6238"
                    fill="#D9D9D9"
                  />
                </g>
                <circle
                  id="Ellipse 14"
                  cx="181.059"
                  cy="252.713"
                  r="42.5743"
                  fill="#ADADAD"
                />
                <rect
                  id="Rectangle 17"
                  x="123.158"
                  y="310.188"
                  width="115.376"
                  height="26.8218"
                  rx="9.36634"
                  fill="#ADADAD"
                />
                <g id="Vector 1" filter="url(#filter2_f_124_555)">
                  <path
                    d="M174.6 266.124L161.969 254.629L156.792 259.95L174.6 275.703L192.98 262.292L210.01 249.52L205.247 242.495L174.6 266.124Z"
                    fill="#B7B7B7"
                  />
                </g>
              </motion.g>
              <motion.g id="capture" initial={{ opacity: 0 }}>
                <g id="Group 2">
                  <g id="header" filter="url(#filter3_f_124_555)">
                    <rect
                      x="134.273"
                      y="82"
                      width="96.4541"
                      height="11.7819"
                      rx="3.12071"
                      fill="#D9D9D9"
                    />
                  </g>
                  <g id="capture 1">
                    <rect
                      id="Rectangle 10"
                      x="83"
                      y="101.53"
                      width="199"
                      height="70.3898"
                      rx="9.36214"
                      fill="#D9D9D9"
                    />
                    <g id="Rectangle 11" filter="url(#filter4_f_124_555)">
                      <rect
                        x="92.1377"
                        y="113.736"
                        width="96.4541"
                        height="12.2063"
                        rx="3.12071"
                        fill="#ADADAD"
                      />
                    </g>
                    <rect
                      id="Rectangle 12"
                      x="92.1377"
                      y="136.522"
                      width="181.74"
                      height="26.4471"
                      rx="9.36214"
                      fill="white"
                    />
                  </g>
                  <g id="capture 2">
                    <rect
                      id="Rectangle 10_2"
                      x="83"
                      y="186.161"
                      width="199"
                      height="131.477"
                      rx="9.36214"
                      fill="#D9D9D9"
                    />
                    <g id="Rectangle 11_2" filter="url(#filter5_f_124_555)">
                      <path
                        d="M92.1377 199.379C92.1377 197.656 93.5349 196.258 95.2584 196.258H185.471C187.195 196.258 188.592 197.656 188.592 199.379V211.778C188.592 213.501 187.195 214.899 185.471 214.899H95.2584C93.5349 214.899 92.1377 213.501 92.1377 211.778V199.379Z"
                        fill="#ADADAD"
                      />
                    </g>
                    <rect
                      id="Rectangle 12_2"
                      x="91.6301"
                      y="223.255"
                      width="181.74"
                      height="40.387"
                      rx="9.36214"
                      fill="white"
                    />
                    <rect
                      id="Rectangle 13"
                      x="92.1377"
                      y="271.889"
                      width="181.74"
                      height="40.387"
                      rx="9.36214"
                      fill="white"
                    />
                  </g>
                </g>
                <g id="Rectangle 15" filter="url(#filter6_f_124_555)">
                  <rect
                    x="188.084"
                    y="453.971"
                    width="93.9158"
                    height="37.0288"
                    rx="9.36214"
                    fill="#F2F2F2"
                  />
                  <rect
                    x="188.307"
                    y="454.194"
                    width="93.47"
                    height="36.583"
                    rx="9.13923"
                    stroke="black"
                    stroke-width="0.445816"
                  />
                </g>
                <g id="Rectangle 16" filter="url(#filter7_f_124_555)">
                  <rect
                    x="83"
                    y="453.971"
                    width="93.9158"
                    height="37.0288"
                    rx="9.36214"
                    fill="#F0F0F0"
                  />
                  <rect
                    x="83.2229"
                    y="454.194"
                    width="93.47"
                    height="36.583"
                    rx="9.13923"
                    stroke="black"
                    stroke-width="0.445816"
                  />
                </g>
              </motion.g>
              <motion.g
                id="templates"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{
                  scale: [1.1, 1.2],
                  opacity: [0.5, 1],
                }}
                transition={{ duration: 1.5 }}
              >
                <motion.g
                  id="1st template"
                  initial={{ opacity: 1, translateX: 0 }}
                  animate={{ opacity: 0, translateX: -250 }}
                  transition={{ duration: 1, delay: 1.5 }}
                >
                  <rect
                    id="Rectangle 3"
                    x="83"
                    y="82"
                    width="196"
                    height="45.25"
                    rx="10.1337"
                    fill="#D9D9D9"
                  />
                  <ellipse
                    id="Ellipse 11"
                    cx="104.259"
                    cy="104.099"
                    rx="12.4444"
                    ry="10.5233"
                    fill="#ADADAD"
                  />
                  <rect
                    id="Rectangle 4"
                    x="133.815"
                    y="97.7849"
                    width="127.037"
                    height="12.6279"
                    rx="3.37791"
                    fill="#ADADAD"
                  />
                </motion.g>
                <motion.g
                  id="2nd template"
                  initial={{ opacity: 1, translateX: 0 }}
                  animate={{ opacity: 0, translateX: 250 }}
                  transition={{ duration: 1, delay: 1.5 }}
                >
                  <rect
                    id="Rectangle 5"
                    x="83"
                    y="149.875"
                    width="196"
                    height="45.25"
                    rx="10.1337"
                    fill="#D9D9D9"
                  />
                  <ellipse
                    id="Ellipse 12"
                    cx="104.259"
                    cy="171.974"
                    rx="12.4444"
                    ry="10.5233"
                    fill="#ADADAD"
                  />
                  <rect
                    id="Rectangle 6"
                    x="133.815"
                    y="165.66"
                    width="127.037"
                    height="12.6279"
                    rx="3.37791"
                    fill="#ADADAD"
                  />
                </motion.g>
                <motion.g
                  id="3rd template"
                  initial={{ opacity: 1, translateX: 0 }}
                  animate={{ opacity: 0, translateX: -250 }}
                  transition={{ duration: 1, delay: 1.7 }}
                >
                  <rect
                    id="Rectangle 7"
                    x="83"
                    y="217.75"
                    width="196"
                    height="45.25"
                    rx="10.1337"
                    fill="#D9D9D9"
                  />
                  <ellipse
                    id="Ellipse 13"
                    cx="104.259"
                    cy="239.849"
                    rx="12.4444"
                    ry="10.5233"
                    fill="#ADADAD"
                  />
                  <rect
                    id="Rectangle 8"
                    x="133.815"
                    y="233.535"
                    width="127.037"
                    height="12.6279"
                    rx="3.37791"
                    fill="#ADADAD"
                  />
                </motion.g>
              </motion.g>
            </g>
            <defs>
              <filter
                id="filter0_d_124_555"
                x="57.8981"
                y="31.1736"
                width="251.424"
                height="496.413"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="3.30575" dy="4.40766" />
                <feGaussianBlur stdDeviation="2.20383" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_124_555"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_124_555"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_f_124_555"
                x="102.297"
                y="186.297"
                width="157.525"
                height="175.406"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.851485"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter2_f_124_555"
                x="155.089"
                y="240.792"
                width="56.6237"
                height="36.6138"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.851485"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter3_f_124_555"
                x="132.49"
                y="80.2167"
                width="100.021"
                height="15.3485"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.891632"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter4_f_124_555"
                x="90.3544"
                y="111.953"
                width="100.021"
                height="15.7729"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.891632"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter5_f_124_555"
                x="90.3544"
                y="194.475"
                width="100.021"
                height="22.2067"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.891632"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter6_f_124_555"
                x="186.301"
                y="452.188"
                width="97.4823"
                height="40.5953"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.891632"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
              <filter
                id="filter7_f_124_555"
                x="81.2167"
                y="452.188"
                width="97.4823"
                height="40.5953"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.891632"
                  result="effect1_foregroundBlur_124_555"
                />
              </filter>
            </defs>
          </svg>
        </Grid>

        <Grid
          item
          xs={6}
          sx={{
            textAlign: "center",
          }}
          // display="flex"
          // alignItems="center"
          // justifyContent="center"
          // flexDirection="column"
        >
          <h1 style={{ color: "#8B0000" }}>
            SSI <span style={{ color: "black" }}>CAPTURE</span>
          </h1>
          <motion.h3
            initial={{ opacity: 0 }}
            transition={{ duration: 2 }}
            whileInView={{ opacity: 1 }}
          >
            About capture app text
          </motion.h3>
          {/* <Button>Find out more</Button> */}
        </Grid>
      </Grid>
    </div>
  );
}

export default ProjectsComponent;
